import axios from "axios";
import {
  CPKeyPersonDetailsType,
  KeyPersonDetailsType,
} from "../pages/types/KeyPersonDetailsType";

export const CPUpdateKeyPerson = (
  keyPersonId: number,
  CPKeyPersonDetails: CPKeyPersonDetailsType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/update/one/tradexwbench.customer_key_person/${keyPersonId}`,
      {
        params: {
          context: {},
          data: CPKeyPersonDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
